import { DocumentViewer, ProviderDocumentUrl, ProviderReceiveFax, renderDate, Spinner } from '@enter/core';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { RootStore } from 'stores';
import { ClaimTimelineStyles as S } from '@enter/core';

interface IReceiveFaxDetailProps {
    receiveFax: ProviderReceiveFax;
}

export const ReceiveFaxDetail: React.FunctionComponent<IReceiveFaxDetailProps> = inject('rootStore')(
    observer(
        (props: IReceiveFaxDetailProps): React.ReactElement => {
            const rootStore: RootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }
            const { claimStore } = rootStore;
            const { receiveFax } = props;
            const [loading, setLoading] = useState(false);
            const [documentUrl, setDocumentUrl] = useState<ProviderDocumentUrl | undefined>();
            useEffect(() => {
                (async (): Promise<void> => {
                    if (receiveFax && receiveFax.document && receiveFax.document.id) {
                        setLoading(true);
                        const url = await claimStore.loadDocumentDownloadUrl(receiveFax.document.id);
                        setDocumentUrl(url);
                        setLoading(false);
                    }
                })();
            }, [receiveFax, claimStore]);
            return (
                <>
                    {loading ? (
                        <Spinner />
                    ) : (
                        <S.ExpandCol>
                            {documentUrl?.url && <DocumentViewer url={documentUrl.url} />}
                            <S.ExpandTable key={receiveFax.id} expand={true}>
                                <S.ExpandTBody>
                                    {!loading && (
                                        <>
                                            <S.ExpandTR>
                                                <S.ExpandTH>From</S.ExpandTH>
                                                <S.ExpandTD>{receiveFax.fromE164}</S.ExpandTD>
                                            </S.ExpandTR>
                                            <S.ExpandTR>
                                                <S.ExpandTH># of Pages</S.ExpandTH>
                                                <S.ExpandTD>{receiveFax.pages}</S.ExpandTD>
                                            </S.ExpandTR>
                                            <S.ExpandTR>
                                                <S.ExpandTH>Received</S.ExpandTH>
                                                <S.ExpandTD>{renderDate(receiveFax.received)}</S.ExpandTD>
                                            </S.ExpandTR>
                                        </>
                                    )}
                                </S.ExpandTBody>
                            </S.ExpandTable>
                        </S.ExpandCol>
                    )}
                </>
            );
        },
    ),
);
